import { Icon, IconProps } from ".";

export const Roll = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M17.1159 12.5H13.4493V16.1667H17.1159V12.5Z" />
        <path d="M20.1715 16.7778H17.7271V19.2222H20.1715V16.7778Z" />
        <path d="M20.7826 12.5H24.4493V16.1667H20.7826V12.5Z" />
        <path d="M17.1159 19.8333H13.4493V23.5H17.1159V19.8333Z" />
        <path d="M20.7826 19.8333H24.4493V23.5H20.7826V19.8333Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8327 9.44173V7H25.0658V9.44173H27.5075V11.8835H29.9493V24.1165H27.5075V26.5339H29.9493V29H12.8327V26.5583H10.391V24.1165H7.94928V11.8835H10.391V9.44173H12.8327ZM12.8572 24.0921H10.4154V11.9079H12.8572V9.46615H25.0414V11.9079H27.4831V24.0921H25.0414V26.5339H12.8572V24.0921Z"
        />
      </>
    </Icon>
  );
};
